import InfiniteScroll from 'react-infinite-scroller';
import Masonry from 'react-masonry-css';

import { useAdsInfinite } from '@/lib/hooks/useInfiniteAdsList';
import AdCard from '@/tayara-kit/ListingItemCard/AdCard';
import { AdType } from '@/tayara-kit/ListingItemCard/types';
import Text from '@/tayara-kit/Text';

import { IListingItem } from '../types';

export interface UserListingsProps {
  adsByUser: IListingItem[];
  countAdByUser: number;
  userId: string;
}
const UserListings = ({
  adsByUser,
  countAdByUser,
  userId,
}: UserListingsProps) => {
  const [adsListData, , loadMoreAdsList] = useAdsInfinite({
    initialAdslistData: adsByUser,
    initialCountTotalAds: countAdByUser,
    isPublic: true,
    userId,
  });

  return (
    <div className="p-1 md:p-3 lg:p-4">
      <div className="space-x-1 mb-2 px-2">
        <Text
          text="Annonces actives"
          className="text-gray-700 font-bold text-sm"
        />
        <Text
          text={`(${countAdByUser})`}
          className="text-primary font-bold text-sm"
        />
      </div>

      <InfiniteScroll
        pageStart={0}
        loadMore={loadMoreAdsList}
        initialLoad={false}
        hasMore={true}
        loader={<div className="loader" key={0}></div>}
        threshold={5000}
      >
        <Masonry
          breakpointCols={{
            default: 7,
            1536: 6,
            1280: 5,
            1024: 4,
            768: 3,
            640: 2,
            320: 1,
          }}
          className="flex md:ml-[-20px] w-auto"
          columnClassName="bg-clip-padding pl-[8px] md:pl-[20px] vertical-masonry-margin"
        >
          {adsListData.map((item: IListingItem) => (
            <AdCard
              adType={AdType.Normal}
              key={item.id}
              adCardData={item as IListingItem}
            />
          ))}
        </Masonry>
      </InfiniteScroll>
    </div>
  );
};

export default UserListings;
